


















import { defineComponent, PropType } from '@vue/composition-api';
import CategoriesInput from '@front-app/components/inputs/CategoriesInput.vue';

const EVENT_TYPES = [
	'event.type.assembly',
	'event.type.attraction',
	'event.type.class',
	'event.type.competition',
	'event.type.conference',
	'event.type.convention',
	'event.type.course',
	'event.type.dinner',
	'event.type.discussion',
	'event.type.education',
	'event.type.expo',
	'event.type.gala',
	'event.type.game',
	'event.type.keynote',
	'event.type.learning',
	'event.type.lecture',
	'event.type.meeting',
	'event.type.other',
	'event.type.party',
	'event.type.plenary',
	'event.type.retreat',
	'event.type.seminar',
	'event.type.social',
	'event.type.symposium',
	'event.type.talk',
	'event.type.tournament',
	'event.type.tradeshow',
	'event.type.webcast',
	'event.type.webinar',
	'event.type.workshop',
];

export default defineComponent({
	components: { CategoriesInput },
	props: {
		selectedEventTypes: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup() {
		return {
			eventTypes: EVENT_TYPES,
		};
	},
});
